import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
// import './styles/main.scss'
import './styles/tailwind.css'
import './styles/vendor/react-select.css'
import './styles/vendor/stripe-spinner.css'
import App from './App.jsx'
import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_SENTRY_ENABLED === "true")  {
    Sentry.init({
        dsn: "https://5876253d18d4d4d53269e2300e62ca4f@o4507226811727872.ingest.de.sentry.io/4509688845959248",
        sendDefaultPii: true
    });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
)
